// extracted by mini-css-extract-plugin
export default {"loginWrapper":"loginPage_loginWrapper__4OO0Y"};